import axios from "axios";
//import moment from 'moment';
const API = process.env.NODE_ENV == "development" ? "https://192.168.112.114/SMSManager" : "https://api.e-kartes.lv/SMSManager";
//axios.defaults.withCredentials = true;

const smsapi = axios.create({
    withCredentials: true,
    baseURL: API,
});
const api = {
    api: API,
    getEvents() {
        return this.apiGetRequest("events/select");
    },
    //users
    getUsers() {
        return this.apiGetRequest("admin/users/select");
    },
    deleteUser(id) {
        return this.apiPostRequest("admin/users/delete/" + id);
    },
    insertUser(data) {
        return this.apiPostRequest("admin/users/insert", data);
    },
    updateUser(data) {
        return this.apiPostRequest("admin/users/update/" + data.idx, data);
    },
    //Finaces
    getAdminFinances() {
        return this.apiGetRequest("admin/finances/select");
    },
    add2companyDebit(id, data) {
        return this.apiPostRequest("admin/finance/add/" + id, data);
    },
    //Companies
    getCompanies() {
        return this.apiGetRequest("admin/companies/select");
    },
    deleteCompany(id) {
        return this.apiPostRequest("admin/companies/delete/" + id);
    },
    insertCompany(data) {
        return this.apiPostRequest("admin/companies/insert", data);
    },
    updateCompany(data) {
        return this.apiPostRequest("admin/companies/update/" + data.idx, data);
    },
    //SmsApi
    getSmsapies() {
        return this.apiGetRequest("admin/smsapies/select");
    },
    deleteSmsapi(id) {
        return this.apiPostRequest("admin/smsapies/delete/" + id);
    },
    insertSmsapi(data) {
        return this.apiPostRequest("admin/smsapies/insert", data);
    },
    updateSmsapi(data) {
        return this.apiPostRequest("admin/smsapies/update/" + data.idx, data);
    },
    //Messages
    getAdminMessages() {
        return this.apiGetRequest("admin/messages/select");
    },
    //Tasks
    getAdminTasks() {
        return this.apiGetRequest("admin/tasks/select");
    },
    getTasksActive() {
        return this.apiGetRequest("tasks/select/active");
    },
    getTasksArchived() {
        return this.apiGetRequest("tasks/select/archived");
    },
    getFinance() {
        return this.apiGetRequest("finance/select");
    },
    getTask(id) {
        return this.apiGetRequest("tasks/id/" + id);
    },
    stopTask(id) {
        return this.apiPostRequest("tasks/stop/" + id);
    },
    updateTask(id, data) {
        return this.apiPostRequest("tasks/update/" + id, data);
    },
    resendTask(id) {
        return this.apiPostRequest("tasks/resend/" + id);
    },
    resetTask(id) {
        return this.apiPostRequest("tasks/reset/" + id);
    },
    archiveTask(id) {
        return this.apiPostRequest("tasks/archive/" + id);
    },
    deleteTask(id) {
        return this.apiPostRequest("tasks/delete/" + id);
    },
    createTask(data) {
        return this.apiPostRequest("tasks/insert", data);
    },
    startTask(id, data) {
        return this.apiPostRequest("tasks/start/" + id, data);
    },
    scheduleTask(id, data) {
        return this.apiPostRequest("tasks/start/" + id, data);
    },
    //templates
    getAdminTemplates() {
        return this.apiGetRequest("admin/templates/select");
    },
    getTemplates() {
        return this.apiGetRequest("templates/select");
    },
    deleteTemplate(id) {
        return this.apiPostRequest("templates/delete/" + id);
    },
    insertTemplate(data) {
        return this.apiPostRequest("templates/insert", data);
    },
    updateTemplate(data) {
        return this.apiPostRequest("templates/update/" + data.idx, data);
    },
    //Lists
    getAdminLists(){
        return this.apiGetRequest("admin/lists/select");
    },
    getLists() {
        return this.apiGetRequest("lists/select");
    },
    getList(id) {
        return this.apiGetRequest("lists/select/" + id);
    },
    insertList(data) {
        return this.apiPostRequest("lists/insert", data);
    },
    updateList(data) {
        return this.apiPostRequest("lists/update/" + data.idx, data);
    },
    copyList(data) {
        return this.apiPostRequest("lists/copy/" + data.idx);
    },
    deleteList(id) {
        return this.apiPostRequest("lists/delete/" + id);
    },
    ping() {
        return new Promise((resolve, reject) => {
            this.apiGetRequest("ping").then(response => {
                this.$vm.$store.commit("user/setUser", response.user)
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    login(data) {
        return this.apiPostRequest("login", data);
    },
    logout() {
        return this.apiPostRequest("logout");
    },
    apiPostRequest(uri, data, pars) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        if (typeof data == "undefined") data = null;
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            smsapi.post(uri, data, {
                params: pars, withCredentials: true,
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        })
    },
    apiGetRequest(uri, pars) {
        if (typeof pars == "undefined" || pars == null) pars = {};
        pars.prevcache = new Date().getTime();
        return new Promise((resolve, reject) => {
            smsapi.get(uri, { params: pars }).then(response => {
                resolve(response.data);
            }).catch(error => {
                this.$vm.$store.commit("user/clearUser")
                this.$vm.$router.push("/login")
                reject(error);
            });
        })
    },

    upper_menu: [
        {
            icon: "fa-calendar-alt",
            text: "sheduler",
            route: "/scheduler",
            open: false
        },
        {
            icon: "fa-users",
            text: "lists",
            route: "/lists",
            open: false
        },
        {
            icon: "fa-clone",
            text: "templates",
            route: "/templates",
            open: false
        },
        {
            icon: "fa-history",
            text: "history",
            route: "/history",
            open: false
        },
        {
            icon: "fa-coins",
            text: "finance",
            route: "/finance",
            open: false
        },
    ]
    ,
    getSavedLocaleAsStr() {
        return localStorage.getItem("lang");
    },
    setLocale(v) {
        //        console.log("set locale to:", v);
        localStorage.setItem("lang", v);
        this.$vm.$i18n.locale = v;
    },
    setVm(vm) {
        this.$vm = vm;
    },
}
export default api;
